export default __webpack_public_path__ + "static/media/renal-icon.fc34224c.svg";